import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100 mb20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fl w30 pad10" }
const _hoisted_4 = { class: "fw600 pad10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, "Salesforce連携を行い、入力されたフォーム内容を連携することが可能です。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "fl w60 mt30" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "連携を有効にするには、担当者にお問い合わせください。", -1)
const _hoisted_10 = {
  key: 1,
  class: "w100"
}
const _hoisted_11 = { class: "fw600 pad10" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, "Salesforce連携を行い、入力されたフォーム内容を連携することが可能です。", -1)
const _hoisted_14 = {
  key: 0,
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_15 = {
  class: "fl",
  style: {"width":"380px"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "fl mt30" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: `is_sandbox_`,
  class: "fs12 pointer"
}, " Sandbox環境を使用", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "fl fs14" }
const _hoisted_21 = {
  class: "w100",
  style: {}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "fl fs14 mt17" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "mt10"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "送信するアクションを選択してください。", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "mt10 hoverLgreyBg pad5 rad8" }
const _hoisted_34 = {
  class: "fl fs13 mt3",
  style: {"width":"300px"}
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "fr mr5" }
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 mt20 fw600" }, "検索項目を選択", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, [
  /*#__PURE__*/_createTextVNode(" 未入力の場合、メールアドレスをキーにリードを検索します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" カスタムオブジェクトの場合、Emailはないため、Email__cなどの項目をキーに検索します。 ")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 mt30 fl" }, "の項目が", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 mt30 fl" }, "と同一のものがなければ作成します。", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = { class: "mt20" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600" }, "リード(カスタムオブジェクト)連携項目", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, " リード(またはカスタムオブジェクト)作成時に設定した項目に値を自動で入れます。 ", -1)
const _hoisted_49 = { class: "fl" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "fl fs20 mt20 mr5" }, "⇒", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = {
  key: 0,
  class: "mb10 mt10"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "padw10 fl" }
const _hoisted_59 = {
  class: /*#__PURE__*/_normalizeClass(`fs14 fw600 mt5`)
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = ["src", "onClick"]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_VariableListsContent = _resolveComponent("VariableListsContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.rm.canUseOption(`management_salesforce`, false))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/logo/logo_salesforce.png`),
                width: "28",
                height: "28",
                class: "pointer fl mr10",
                style: {"margin-top":"-8px"}
              }, null, 8, _hoisted_5),
              _createTextVNode("Salesforce連携 ")
            ]),
            _hoisted_6,
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              type: "submit",
              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
              style: {"height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestSalesforce && _ctx.requestSalesforce(...args)))
            }, " リクエスト ")
          ])
        ]))
      : (_ctx.notiDic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(`fl  pad10 ${_ctx.scope == `room_setting` ? `w100` : `w30`}`)
            }, [
              _createElementVNode("h5", _hoisted_11, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/logo/logo_salesforce.png`),
                  width: "28",
                  height: "28",
                  class: "pointer fl mr10",
                  style: {"margin-top":"-8px"}
                }, null, 8, _hoisted_12),
                _createTextVNode("Salesforce連携 ")
              ]),
              _hoisted_13
            ], 2),
            (_ctx.scope == `user`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      (_ctx.notiDic.id == `new`)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                              type: "submit",
                              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                              style: {"height":"50px"},
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goSalesforce && _ctx.goSalesforce(...args)))
                            }, " OAuth連携 "),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_CheckboxTag, {
                                value: ``,
                                name: `is_sandbox`,
                                checked: _ctx.notiDic.settings.is_sandbox,
                                prefix: `is_sandbox`,
                                onClickCheckbox: _ctx.changeIsSandbox,
                                class: "ml1"
                              }, null, 8, ["checked", "onClickCheckbox"]),
                              _hoisted_18
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("p", _hoisted_20, "連携SalesforceアカウントID: " + _toDisplayString(_ctx.notiDic.settings.provider_account_id), 1),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "fl pointer centered circle_button with_white_bg fs14 rad8 mt15 alertRed noborder underline mr20",
                              style: {"height":"50px"},
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSalesforce && _ctx.removeSalesforce(...args)))
                            }, " 連携解除 ")
                          ]))
                    ])
                  ])
                ]))
              : (_ctx.scope == `room_setting`)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`fl ${_ctx.scope == `room_setting` ? `w100 pad20` : `w60`}`)
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", null, [
                        (_ctx.notiDic.id == `new`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              (!_ctx.connectableNotis)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "submit",
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                    style: {"height":"50px"},
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.connectSalesforce && _ctx.connectSalesforce(...args)))
                                  }, " 公開ページに紐付ける "))
                                : (_ctx.connectableNotis)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      (_ctx.connectableNotis.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "連携できるアカウントが見つかりませんでした。"))
                                        : (_ctx.connectableNotis.length >= 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                              _createVNode(_component_SelectTag, {
                                                name: "select_salesforces",
                                                id: "select_salesforces",
                                                class: "fl fs14 roundForm w100",
                                                style: {"min-width":"30px","height":"50px","max-width":"150px"},
                                                options: _ctx.connectableNotis.map(noti => noti.settings.provider_account_id),
                                                defaultOption: null,
                                                needUnselect: true,
                                                onSelectValue: _ctx.selectSalesforce
                                              }, null, 8, ["options", "onSelectValue"])
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("p", _hoisted_27, " 連携SalesforceアカウントID: " + _toDisplayString(_ctx.truncate(_ctx.notiDic.settings.provider_account_id, 30)), 1),
                              _createElementVNode("button", {
                                type: "submit",
                                class: "fl pointer centered circle_button with_white_bg fs14 rad8 alertRed noborder underline",
                                style: {"height":"50px"},
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.disconnectSalesforce && _ctx.disconnectSalesforce(...args)))
                              }, " 解除 "),
                              _hoisted_28,
                              (_ctx.availableEvents && _ctx.showRegisterForm)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createVNode(_component_SelectTag, {
                                      name: "select_available_events",
                                      id: "select_available_events",
                                      class: "fl fs14 roundForm w100 mr5 mt10",
                                      style: {"min-width":"30px","height":"50px","max-width":"120px"},
                                      options: _ctx.availableEvents.map(e => e.name),
                                      defaultOption: null,
                                      needUnselect: true,
                                      onSelectValue: _ctx.selectEvent
                                    }, null, 8, ["options", "onSelectValue"]),
                                    _createVNode(_component_SelectTag, {
                                      name: "select_register_type",
                                      id: "select_register_type",
                                      class: "fl fs14 roundForm w100 mr5 mt10",
                                      style: {"min-width":"30px","height":"50px","max-width":"180px"},
                                      options: _ctx.CustomNotification.salesforceRegisterTypes().map(m => m.name),
                                      defaultOption: null,
                                      needUnselect: true,
                                      onSelectValue: _ctx.selectRegisterType
                                    }, null, 8, ["options", "onSelectValue"]),
                                    ([`sf_custom_objects`, `sf_custom_objects_and_events`].includes(_ctx.registerType))
                                      ? (_openBlock(), _createBlock(_component_MdTextfieldTag, {
                                          key: 0,
                                          name: "カスタムオブジェクト名を入力",
                                          fieldStyle: "min-width:250px;max-width:250px;",
                                          style: {"height":"56px","min-width":"250px"},
                                          class: "fs14 fl",
                                          placeholder: `カスタムオブジェクト名を入力`,
                                          value: _ctx.customObjectName,
                                          onInputValue: _ctx.inputCustomObjectName
                                        }, null, 8, ["value", "onInputValue"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      class: "fl pointer centered circle_button fs14 rad8 noborder skyblueBg mt10",
                                      style: {"height":"50px"},
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addEvent && _ctx.addEvent(...args)))
                                    }, " 追加 ")
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_31,
                              (_ctx.notiDic.events && _ctx.availableEvents)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notiDic.events, (ev, evindex) => {
                                      return (_openBlock(), _createElementBlock("div", { key: evindex }, [
                                        _createElementVNode("div", _hoisted_33, [
                                          _createElementVNode("div", _hoisted_34, [
                                            _createTextVNode(_toDisplayString(_ctx.availableEvents.find(e => e.timing == ev).name) + "時に ", 1),
                                            (_ctx.notiDic.settings[ev])
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                                  _createTextVNode(_toDisplayString(_ctx.CustomNotification.salesforceRegisterTypes().find(
                                                        m => m.value == _ctx.notiDic.settings[ev].register_type
                                                    ).name) + " ", 1),
                                                  (
                                                        [`sf_custom_objects`, `sf_custom_objects_and_events`].includes(
                                                            _ctx.notiDic.settings[ev].register_type
                                                        )
                                                    )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, " (" + _toDisplayString(_ctx.notiDic.settings[ev].custom_object_name) + ") ", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("img", {
                                              src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                              width: "20",
                                              height: "23",
                                              class: "pointer",
                                              onClick: ($event: any) => (_ctx.deleteSettingDic(ev))
                                            }, null, 8, _hoisted_38)
                                          ]),
                                          _hoisted_39
                                        ])
                                      ]))
                                    }), 128)),
                                    _hoisted_40,
                                    _createElementVNode("div", null, [
                                      _hoisted_41,
                                      _hoisted_42,
                                      _createVNode(_component_MdTextfieldTag, {
                                        name: "カスタムキー名を入力",
                                        fieldStyle: "min-width:150px;max-width:150px;",
                                        style: {"height":"56px","min-width":"150px"},
                                        class: "fs14 fl",
                                        placeholder: `カスタムキー名を入力  Email__cなど`,
                                        value: _ctx.notificationSettings.sf_search_key,
                                        onInputValue: _ctx.inputSearchKey
                                      }, null, 8, ["value", "onInputValue"]),
                                      _hoisted_43,
                                      (_ctx.rcm.fields)
                                        ? (_openBlock(), _createBlock(_component_SelectTag, {
                                            key: 0,
                                            name: "select_search_field",
                                            id: "select_search_field",
                                            class: "fl fs14 roundForm w100 mr5 mt10",
                                            style: {"min-width":"30px","height":"50px","max-width":"180px"},
                                            options: _ctx.rcm.fields.map(m => m.field_name),
                                            defaultOption: 
                                            _ctx.rcm.fields.find(
                                                m => m.public_id == _ctx.notificationSettings.sf_search_form_field_public_id
                                            )?.field_name
                                        ,
                                            needUnselect: true,
                                            onSelectValue: _ctx.selectLeadSearchField
                                          }, null, 8, ["options", "defaultOption", "onSelectValue"]))
                                        : _createCommentVNode("", true),
                                      _hoisted_44
                                    ]),
                                    _hoisted_45,
                                    _createElementVNode("div", _hoisted_46, [
                                      _hoisted_47,
                                      _hoisted_48,
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_49, [
                                          _createVNode(_component_MdTextfieldTag, {
                                            fieldStyle: "min-width:100px;max-width:320px",
                                            style: {"height":"56px","max-width":"320px"},
                                            class: "fl fs16 mr5 mb5",
                                            type: `sf_value`,
                                            name: `waaqから挿入するデータ`,
                                            placeholder: `waaqから挿入するデータ`,
                                            value: _ctx.leadFieldDic.value,
                                            onInputValue: _ctx.inputLeadFieldValue,
                                            required: ""
                                          }, null, 8, ["value", "onInputValue"]),
                                          _hoisted_50,
                                          _createElementVNode("div", {
                                            class: "pointer fl rad6 borderGrey hoverGrey fs12 padw3",
                                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openValBox && _ctx.openValBox(...args)))
                                          }, " +変数を追加 "),
                                          _hoisted_51
                                        ]),
                                        _hoisted_52,
                                        _createVNode(_component_MdTextfieldTag, {
                                          fieldStyle: "min-width:100px;max-width:220px",
                                          style: {"height":"56px","max-width":"220px"},
                                          class: "fl fs16 mr5",
                                          type: `sf_field_name`,
                                          name: `Salesforce項目名`,
                                          placeholder: `Salesforce項目名`,
                                          value: _ctx.leadFieldDic.sf_field_name,
                                          onInputValue: _ctx.inputSfFieldName,
                                          required: ""
                                        }, null, 8, ["value", "onInputValue"]),
                                        _createElementVNode("button", {
                                          type: "submit",
                                          class: "fl pointer centered circle_button fs14 rad8 noborder lskyblueBg mt10",
                                          style: {"height":"50px"},
                                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addLeadField && _ctx.addLeadField(...args)))
                                        }, " 追加 "),
                                        _hoisted_53,
                                        (_ctx.openVariablesBox)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                              _createVNode(_component_VariableListsContent, {
                                                onSelectVariable: _ctx.selectVariable,
                                                type: `title`
                                              }, null, 8, ["onSelectVariable"]),
                                              _hoisted_55
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _hoisted_56,
                                      (_ctx.connectedLeadFields)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.connectedLeadFields, (conv, convindex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: convindex,
                                              class: "borderGrey rad4"
                                            }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("img", {
                                                  src: _ctx.$getAssetImageUrl(`/assets/icons/box_two.png`),
                                                  height: "30",
                                                  width: "30",
                                                  class: "fl mt10 ml10"
                                                }, null, 8, _hoisted_57),
                                                _createElementVNode("div", _hoisted_58, [
                                                  _createElementVNode("p", _hoisted_59, [
                                                    _createTextVNode(_toDisplayString(conv.name == `not_in_waaq` ? `waaqにない項目` : conv.name) + " ⇒ " + _toDisplayString(conv.sf_field_name), 1),
                                                    (_ctx.Util.isPresent(conv.sf_default_value))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, "(" + _toDisplayString(conv.sf_default_value) + ")", 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _createElementVNode("img", {
                                                  src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                                  width: "20",
                                                  height: "23",
                                                  class: "pointer fr mr15 mt12",
                                                  onClick: ($event: any) => (_ctx.removeLeadField(conv))
                                                }, null, 8, _hoisted_61),
                                                _hoisted_62
                                              ]),
                                              _hoisted_63
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
    _hoisted_64
  ]))
}